import React from 'react';
import { DefaultLegendContent, DefaultLegendContentProps, TooltipProps } from 'recharts';
import { Box, Typography } from '@mui/material';
import { WeeklyChartDataType } from '../types';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

export const getProjectKeys = (data: WeeklyChartDataType[]) => {
  const keySet = new Set<string>();

  data.forEach(week => {
    Object.keys(week).forEach(key => {
      if (key !== 'name' && key !== 'pyloadData') {
        keySet.add(key);
      }
    });
  });

  return Array.from(keySet);
};

export const CustomTooltip = ({ active, payload }: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length) {
    const weekRange = payload[0]?.payload?.pyloadData ?? '–';
    const total = payload.reduce((sum: number, entry: any) => sum + (entry.value ?? 0), 0);

    return (
      <Box bgcolor="background.paper" border="1px solid" borderColor="border.default" p={1}>
        <Typography variant="subtitle2">Week: {weekRange}</Typography>

        {payload.map((entry: any, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={i} display="flex" alignItems="center" gap={1}>
            <Box sx={{ width: 10, height: 10, background: entry.color }} />
            <Typography variant="body2">{`${entry.name}: ${entry.value}%`}</Typography>
          </Box>
        ))}

        <Typography variant="subtitle2" mt={1}>
          Total: {total}%
        </Typography>
      </Box>
    );
  }

  return null;
};

export const CustomizedYAxisLabel = ({
  viewBox,
}: {
  viewBox?: { x: number; y: number; height: number };
  label?: string;
  color?: string;
}) => {
  if (!viewBox) {
    return null;
  }
  const { x, y, height } = viewBox;
  const cx = x + 25;
  const cy = y + height / 2;

  return (
    <text
      x={cx}
      y={cy}
      transform={`rotate(-90, ${cx}, ${cy})`}
      textAnchor="middle"
      fill="var(--mui-palette-text-primary)"
      fontSize="12"
    >
      Total Load (%)
    </text>
  );
};

export const CustomLegend = (props: DefaultLegendContentProps) => {
  const { payload = [] } = props;

  const extendedPayload = [
    ...payload,
    {
      value: 'Target (100%)',
      type: 'plainline',
      color: 'var(--mui-palette-neutral-main)',
      id: 'ref-line',
      payload: {
        strokeDasharray: '7 4',
      },
    },
  ];

  return <DefaultLegendContent {...(props as any)} payload={extendedPayload as any} />;
};
